
export const properties = {
    debugLog: false && process.env.NODE_ENV !== "production",
    apiDomain : "/api",
    webAppDomain: 'https://timberstorage.iokrono.com',
};
